<template>
    <div class="copyable-field">
        <span
            class="copyable-field__text"
            :class="{ 'copyable-field__text--copyable': !!value }"
            :title="value ? '双击复制' : ''"
            @selectstart="handleSelectStart"
            @dblclick="handleDblClick"
        >{{ displayText }}</span>
    </div>
</template>

<script>
export default {
    name: 'CopyableField',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        emptyText: {
            type: String,
            default: '--'
        }
    },
    computed: {
        displayText() {
            return this.value || this.emptyText;
        }
    },
    methods: {
        handleSelectStart(e) {
            if (this.value) {
                e.preventDefault();
            }
        },
        handleDblClick() {
            if (!this.value) {
                return;
            }

            this.handleCopy();
            this.$nextTick(function () {
                var sel = window.getSelection && window.getSelection();
                if (sel && sel.removeAllRanges) {
                    sel.removeAllRanges();
                }
            });
        },
        handleCopy() {
            var text = String(this.value || '');

            if (!text) {
                return;
            }

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(this.showSuccess).catch(this.copyByTextarea);
                return;
            }

            this.copyByTextarea();
        },
        copyByTextarea() {
            var textarea = document.createElement('textarea');
            textarea.value = String(this.value || '');
            textarea.setAttribute('readonly', 'readonly');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();

            try {
                document.execCommand('copy');
                this.showSuccess();
            } finally {
                document.body.removeChild(textarea);
            }
        },
        showSuccess() {
            this.$message.success({
                message: '已复制',
                duration: 1000
            });
        }
    }
};
</script>

<style scoped>
.copyable-field {
    display: block;
    min-width: 0;
}

.copyable-field__text {
    color: #303133;
    word-break: break-all;
}

.copyable-field__text--copyable {
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.copyable-field__text--copyable::selection {
    background: transparent;
}

.copyable-field__text--copyable::-moz-selection {
    background: transparent;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CopyableField.vue